module.exports = __webpack_public_path__ + "static/media/refillModule.f49f63eb.png";